<template>
  <v-card>
    <v-card-title>
      {{ $t('title.settings_others') }}
    </v-card-title>
    <v-card-text>
      <template v-if="IS_ANDROID">
        <v-switch
          v-model="startWithAndroid"
          :label="`${$t('field.settings.startWithAndroid')} ${startWithAndroid ? 'ON' : 'OFF'}`"
          color="accent"
          class="mt-0"
          hide-details
        />

        <v-divider class="mt-3" />

        <v-switch
          v-model="usevibrate"
          :label="`${$t('field.settings.vibration')} ${usevibrate ? 'ON' : 'OFF'}`"
          color="accent"
          hide-details
        />
        <v-switch
          v-model="keepscreenon"
          :label="`${$t('field.settings.lock_standby')} ${keepscreenon ? 'ON' : 'OFF'}`"
          color="accent"
          hide-details
        />
        <v-switch
          v-model="usebrightness"
          :label="`${$t('field.settings.darkening')} ${usebrightness ? 'ON' : 'OFF'}`"
          color="accent"
          hide-details
        />
        <v-select
          v-show="usebrightness"
          v-model="duration"
          class="mt-2"
          :label="$t('field.settings.darkening_delay')"
          :items="DurationEnum"
          hide-details
          solo
        />

        <v-divider class="my-3" />

        <v-switch
          v-model="remoteAuto.used"
          :label="`${$t('field.settings.remote_auto')} ${remoteAuto.used ? 'ON' : 'OFF'}`"
          color="accent"
          hide-details
          @change="handleChangeRemoteAuto"
        />
        <time-dialog
          v-if="remoteAuto.used"
          :current="remoteAuto.time"
          @set-time="updateRemoteAuto"
          @cancel="handleChangeRemoteAuto(false)"
        />
      </template>
      <v-select
        v-if="!IS_PAX"
        v-model="orientation"
        :label="$t('field.settings.orientation')"
        :items="orientations"
        class="d-none d-sm-block"
        hide-details
        solo
      />
    </v-card-text>
  </v-card>
</template>

<script>
import { MetierLocalStorage } from 'modulelocalstorage'
import { DurationEnum, OrientationEnum } from '@/modules/Enums'
import { getTimeRemaining, startRemoteSettingsScheduler } from '@/modules/Utils'
import TimeDialog from '@/components/modal/TimeDialog'

export default {
  name: 'CommonSettings',

  components: {
    TimeDialog
  },

  data () {
    return {
      IS_ANDROID,
      IS_PAX,
      DurationEnum,
      startWithDevice: localStorage.getItem('startWithAndroid') === 'true',
      remoteAuto: MetierLocalStorage.getRemoteSettingsAuto()
    }
  },

  computed: {
    orientation: {
      get () {
        return MetierLocalStorage.getScreenOrientation()
      },
      set (val) {
        MetierLocalStorage.setScreenOrientation(val)
        screen.orientation.lock(val)
      }
    },
    startWithAndroid: {
      get () { return this.startWithDevice },
      set (val) {
        this.startWithDevice = val
        localStorage.setItem('startWithAndroid', val)
        CissAndroid.setStartWithDevice(val)
      }
    },
    usevibrate: {
      get () {
        return this.$store.state.usevibrate
      },
      set (val) {
        this.$store.commit('usevibrate', val)
        localStorage.setItem('usevibrate', val)
        // Send use vibration to toolbar
        this.$emit('set-vibration', val)
      }
    },
    usebrightness: {
      get () {
        return this.$store.state.usebrightness
      },
      set (val) {
        this.$store.commit('usebrightness', val)
        localStorage.setItem('usebrightness', val)
        // Send use brightness to toolbar
        this.$emit('set-brightness', val)
      }
    },
    keepscreenon: {
      get () {
        return this.$store.state.keepscreenon
      },
      set (val) {
        this.$store.commit('keepscreenon', val)
        localStorage.setItem('keepscreenon', val)
        // Set KeepScreenOn
        if (cordova.plugins.brightness) {
          cordova.plugins.brightness.setKeepScreenOn(val)
        }
      }
    },
    duration: {
      get () { return this.$store.state.duration },
      set (val) {
        this.$store.commit('duration', val)
        localStorage.setItem('duration', val)
      }
    },
    orientations () {
      const res = []
      OrientationEnum.forEach(type => {
        res.push({
          text: this.$i18n.t(type.text),
          value: type.value
        })
      })
      return res
    }
  },

  methods: {
    handleChangeRemoteAuto (used) {
      this.remoteAuto.used = used
      MetierLocalStorage.setRemoteSettingsAuto(this.remoteAuto)

      if (used && this.remoteAuto.time !== null) {
        this.startScheduler()
      } else {
        SchedulerPlugin.stop()
      }
    },
    updateRemoteAuto (time) {
      this.remoteAuto.time = time.replace(':', '')
      MetierLocalStorage.setRemoteSettingsAuto(this.remoteAuto)

      this.startScheduler()
    },
    startScheduler () {
      startRemoteSettingsScheduler(getTimeRemaining())
    }
  }
}
</script>
